<template>
    <div class="c-product-data-recurring-subscription">
        <b-row>
            <b-col lg="4">
                <b-row class="mt-3">
                    <b-col>
                        <b-row>
                            <b-col>
                                <InputCurrency
                                        :label="Core.Definition.getDefinition('Prix régulier')"
                                        v-model="dataValue.regularPrice"></InputCurrency>
                            </b-col>
                            <b-col>
                                <InputCheckbox
                                        :label="Core.Definition.getDefinition('Taxable')"
                                        v-model="dataValue.isTaxable"></InputCheckbox>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="4">
                <b-row class="mt-3">
                    <b-col>
                        <InputNumber
                                :label="Core.Definition.getDefinition('Limite de réservation')"
                                v-model="dataValue.bookingLimit"></InputNumber>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col>
                        <InputSelect
                                :label="Core.Definition.getDefinition('Expiration après achat')"
                                :options="Core.Product.periodOptions()"
                                :description="dataExpirationDescription"
                                v-model="dataValue.expirationPeriod"></InputSelect>
                    </b-col>
                    <b-col>
                        <InputNumber
                                :label="Core.Definition.getDefinition('Durée') + ' (' + Core.Select.label(dataValue.expirationPeriod, Core.Product.periodOptions()) + ')'"
                                v-model="dataValue.expirationPeriodLength"></InputNumber>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Alert from './Alert'
    import InputSelect from './InputSelect'
    import InputDate from './InputDate'
    import InputText from './InputText'
    import InputCurrency from './InputCurrency'
    import InputCC from './InputCC'
    import InputNumber from "./InputNumber"
    import InputCheckbox from "./InputCheckbox";
    export default {
        name: 'ProductDataLimitedSubscription',
        components: {
            InputCheckbox,
            InputCurrency,
            InputSelect,
            InputText,
            InputDate,
            InputCC,
            Alert,
            InputNumber
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: function () {}
            },
            form: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue: {
                handler(val) {
                    this.dataExpirationDescription = Core.Text.format(Core.Definition.getDefinition('Expiration {0} {1} après achat. La valeur est ignorée si est égale à 0.'), val.expirationPeriodLength, Core.Select.label(val.expirationPeriod, Core.Product.periodOptions()))
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        mounted() {
            this.dataValue = window.Core.Array.newObject(this.value)
        },
        data: () => {
            return {
                Core: window.Core,
                dataExpirationDescription: '',
                dataValue: {
                    regularPrice: '0',
                    expirationPeriod: Core.Value.selectValue(Core.Product.periodMonth, Core.Product.periodOptions()),
                    expirationPeriodLength: '0',
                    periodLength: '0',
                    period: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                    periodPaymentInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                    periodPayment: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                    periodPaymentLength: '0',
                    bookingLimitManagement: false,
                    bookingLimit: '0',
                    attributes: [],
                    variations: [],
                    ticketIsEnabled: false,
                    ticketTemplate: null
                }
            }
        },
        methods: {
        }
    }
</script>
